import React from "react";
import Button from "@mui/joy/Button";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import ModalClose from "@mui/joy/ModalClose";
import Typography from "@mui/joy/Typography";
import Divider from "@mui/joy/Divider";
import Sheet from "@mui/joy/Sheet";
import {isProxyUnmapped, Proxy, ProxyDestination, ProxyDestinationDescription} from "../../models/proxy";
import Input from "@mui/joy/Input";
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import FormHelperText from '@mui/joy/FormHelperText';
import Select from "@mui/joy/Select";
import Option from "@mui/joy/Option";
import {formatDateTime} from "../../common/dateTime";

type DefaultProps = {
    proxy: Proxy
    open: boolean
    setOpen: (e: boolean) => void
    onConfirm: (proxy: Proxy) => void
}

const EditorDialog = (props: DefaultProps) => {
    const {proxy, open, setOpen, onConfirm} = props;
    const [proxyHost, setProxyHost] = React.useState(proxy.proxyHost);
    const [proxyPort, setProxyPort] = React.useState<string>(proxy.proxyPort?.toString?.() ?? "");
    const [proxyLogin, setProxyLogin] = React.useState(proxy.proxyLogin);
    const [proxyPassword, setProxyPassword] = React.useState(proxy.proxyPassword);
    const [destination, setDestination] = React.useState<ProxyDestination>(proxy.destination ?? ProxyDestination.General);
    const [externalId, setExternalId] = React.useState(proxy.externalId ?? "");
    return (
        <Modal open={open} onClose={() => setOpen(false)}>
            <ModalDialog>
                <ModalClose/>
                <Typography id="filter-modal" level="h2">
                    {proxy.id > 0 ? 'Редактировать прокси' : 'Создать новый прокси'}
                </Typography>
                <Divider sx={{my: 2}}/>
                <Sheet sx={{display: 'flex', flexDirection: 'column', gap: 2}}>
                    <FormControl>
                        <FormLabel>Хост</FormLabel>
                        <Input placeholder="Хост" value={proxyHost}
                               onChange={(event) => setProxyHost(event.target.value)}/>
                    </FormControl>
                    <FormControl>
                        <FormLabel>Порт</FormLabel>
                        <Input placeholder="Порт" value={proxyPort}
                               onChange={(event) => setProxyPort(event.target.value)}/>
                    </FormControl>
                    <FormControl>
                        <FormLabel>Логин</FormLabel>
                        <Input placeholder="Логин" value={proxyLogin}
                               onChange={(event) => setProxyLogin(event.target.value)}/>
                    </FormControl>
                    <FormControl>
                        <FormLabel>Пароль</FormLabel>
                        <Input placeholder="Пароль" value={proxyPassword}
                               onChange={(event) => setProxyPassword(event.target.value)}/>
                    </FormControl>
                    <FormControl>
                        <FormLabel>Предназначение</FormLabel>
                        <Select value={destination}
                                onChange={(_, value) => setDestination(value ?? ProxyDestination.General)}>
                            {
                                Object.entries(ProxyDestinationDescription).map((entity) => <Option key={Number(entity[0])}
                                        value={Number(entity[0])}>{entity[1]}</Option>)
                            }
                        </Select>
                    </FormControl>
                    <FormControl color={isProxyUnmapped({id: proxy.id, externalId}) ? 'warning' : undefined}>
                        <FormLabel>ExternalId</FormLabel>
                        <Input placeholder="id слота Proxy-seller"
                               value={externalId}
                               onChange={(event) => setExternalId(event.target.value)}/>
                        {isProxyUnmapped({id: proxy.id, externalId}) &&
                            <FormHelperText>
                                Нет сопоставления со слотом вендора. Дождитесь сверки или впишите id вручную.
                            </FormHelperText>
                        }
                    </FormControl>
                    {proxy.id > 0 &&
                        <FormControl>
                            <FormLabel>Изменён</FormLabel>
                            <Input value={formatDateTime(proxy.updated)} disabled/>
                        </FormControl>
                    }
                    <Button
                        onClick={() => setOpen(false)}
                        color="neutral"
                    >
                        Отмена
                    </Button>
                    <Button
                        onClick={() => {
                            setOpen(false);
                            const trimmedExternalId = externalId.trim();
                            onConfirm({
                                id: proxy.id,
                                proxyLogin,
                                proxyPort: Number(proxyPort) || 0,
                                proxyHost,
                                proxyPassword,
                                destination,
                                connectionFailures: proxy.connectionFailures,
                                updated: proxy.updated,
                                // Update: пустая строка очищает поле. Create: не передаём, если пусто.
                                externalId: proxy.id > 0 ? trimmedExternalId : (trimmedExternalId || undefined)
                            });
                        }}
                        color="primary"
                    >
                        Сохранить
                    </Button>
                </Sheet>
            </ModalDialog>
        </Modal>
    );
};

export default EditorDialog;